import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface DashboardVendaInternaGerencialVendedor {
  sellerId: number;
  nome: string;
  foto: string;
  totalLigacoes: number;
  totalRealizadas: number;
  ligacaoGanho: number;
  ligacaoPerda: number;
  percentualRealizadas: number;
  totalAgendado: number;
  realizadoAgendado: number;
  percentualAgendado: number;
  totalGerado: number;
  realizadoGerado: number;
  percentualGerado: number;
  totalManual: number;
  realizadoManual: number;
  percentualManual: number;
  vendas: number;
  litros: number;
  pedidos: number;
  percentualPedidos: number;
  naoComprou: number;
  percentualNaoComprou: number;
  totalWhatsapp: number;
  whatsappAtendimento: number;
  whatsappGanho: number;
  whatsappPerda: number;
  totalAtendimentos: number;
  totalGanhos: number;
  totalPerdas: number;
  percentualGanhoGeral: number;
}

export interface DashboardVendaInternaGerencialResumo {
  totalLigacoes: number;
  totalRealizadas: number;
  totalLigacaoGanho: number;
  totalLigacaoPerda: number;
  percentualRealizadas: number;
  totalWhatsapp: number;
  totalWhatsappAtendimento: number;
  totalWhatsappGanho: number;
  totalWhatsappPerda: number;
  totalAtendimentos: number;
  totalGanhos: number;
  totalPerdas: number;
  percentualGanhoGeral: number;
  totalVendas: number;
  totalLitros: number;
  totalPedidos: number;
  totalNaoComprou: number;
  podeAtualizarFotos: boolean;
  vendedores: DashboardVendaInternaGerencialVendedor[];
}

@Injectable({ providedIn: 'root' })
export class DashboardVendaInternaGerencialService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private toastr: ToastrService
  ) { }

  public getResumo(): Observable<DashboardVendaInternaGerencialResumo> {
    const payload = {
      userId: parseInt(localStorage.getItem('id'))
    };

    return this.http
      .post<DashboardVendaInternaGerencialResumo>(this.baseUrl + 'api/DashboardVendaInternaGerencial/GetResumo', payload)
      .pipe(
        catchError(() => {
          this.toastr.error('', 'Erro ao carregar Venda Interna Gerencial. Contate o suporte...');
          return of({
            totalLigacoes: 0,
            totalRealizadas: 0,
            totalLigacaoGanho: 0,
            totalLigacaoPerda: 0,
            percentualRealizadas: 0,
            totalWhatsapp: 0,
            totalWhatsappAtendimento: 0,
            totalWhatsappGanho: 0,
            totalWhatsappPerda: 0,
            totalAtendimentos: 0,
            totalGanhos: 0,
            totalPerdas: 0,
            percentualGanhoGeral: 0,
            totalVendas: 0,
            totalLitros: 0,
            totalPedidos: 0,
            totalNaoComprou: 0,
            podeAtualizarFotos: false,
            vendedores: []
          });
        })
      );
  }

  public updateSellerFoto(sellerId: number, foto: string): Observable<boolean> {
    const payload = {
      userId: parseInt(localStorage.getItem('id')),
      sellerId,
      foto
    };

    return this.http
      .post<boolean>(this.baseUrl + 'api/DashboardVendaInternaGerencial/UpdateSellerFoto', payload)
      .pipe(
        catchError(() => {
          this.toastr.error('', 'Erro ao atualizar foto. Contate o suporte...');
          return of(false);
        })
      );
  }
}
